import { journalsServiceApi } from "@entities/api";

interface ICreateSectionFourRecord {
  itemNoVersionId: string;
  sectionFourRequest: {
    mainJournalId: string;
    section4Id: string;
    section4ListId: string;
    itemPartOneId: string;
    itemPartTwo: {
      defectFixingFactDate: string;
      otherDocuments: {
        fileMetadata: {
          fileNumber: number;
          fileName: string;
          fileType: string;
          fileContentLength: number;
        };
      }[];
      defectFixingInspectionEmployeeId: string;
    };
  };
}

export async function createSectionFourTwoRecord({
  itemNoVersionId,
  sectionFourRequest,
}: ICreateSectionFourRecord) {
  const formData = new FormData();

  formData.append(
    "updateRequest",
    new Blob([JSON.stringify(sectionFourRequest)], {
      type: "application/json",
    }),
  );

  sectionFourRequest.itemPartTwo.otherDocuments?.forEach((doc: any) => {
    if (doc.file) {
      formData.append("otherFiles", doc.file);
    }
  });

  const response = await journalsServiceApi.postForm(
    `/journals/section-four/items/${itemNoVersionId}/secondPartAdd`,
    formData,
  );

  return response.data;
}
